<template>
  <vehicules-list vehicule-step="en_attente_de_destockage" />

</template>

<script>

import VehiculesList from './VehiculesList.vue'

export default {
  components: {
    VehiculesList,
  },
}
</script>

<style lang="scss" scoped>

</style>
